const url ="/v1/"

export default url
